import { LocalStorage } from 'core/decorators';

import { CACHE_MINUTES, STORAGE_MAX_SIZE } from './constants';

let LS_KEY;

function expiryTime() {
  const ttl = 1000 * 60 * CACHE_MINUTES;
  const now = new Date();

  return now.getTime() + ttl;
}

function getReactionsFromLS() {
  return JSON.parse(LocalStorage.getItem(LS_KEY)) || [];
}

function getReaction(id) {
  const reactions = getReactionsFromLS();
  return reactions.find(({ id: localId }) => localId === id);
}

export function updateExpiredReactionInLS(id, reactions, lsKey) {
  LS_KEY = lsKey;
  const reactionsLS = getReactionsFromLS();
  const reactionLS = getReaction(id);

  const newReaction = {
    ...reactionLS,
    expiry: expiryTime(),
    values: reactions,
  };

  LocalStorage.setItem(
    LS_KEY,
    JSON.stringify(reactionsLS.map(oldReaction => oldReaction.id === newReaction.id ? newReaction : oldReaction))
  );
}

export function updateReactionInLS(id, reactions, lsKey) {
  LS_KEY = lsKey;
  const reactionsLS = getReactionsFromLS();
  const reactionLS = getReaction(id);

  const newReaction = { ...reactions, expiry: expiryTime() };

  if (reactionLS) {
    LocalStorage.setItem(
      LS_KEY,
      JSON.stringify(reactionsLS.map(oldReaction => oldReaction.id === newReaction.id ? newReaction : oldReaction))
    );
    return;
  }

  /**
   * Ограничиваем максимальный размер стораджа по размеру.
   */
  if (reactionsLS.length === STORAGE_MAX_SIZE) {
    reactionsLS.shift();
  }

  LocalStorage.setItem(
    LS_KEY,
    JSON.stringify(reactionsLS.concat(newReaction))
  );
}

export function checkReactionFromLSExpired(id, lsKey) {
  LS_KEY = lsKey;
  const now = new Date();
  const reactionLS = getReaction(id);

  if (!reactionLS) return null;

  return now.getTime() > reactionLS.expiry;
}

export function getReactionFromLS(id, lsKey) {
  LS_KEY = lsKey;
  return getReaction(id);
}
